
<div *ngIf="MainSurveyTemplate != null" class="container-app-survey">

  <div *ngIf="displaySurvey" class="background-window mat-drawer-backdrop mat-drawer-shown"></div>

  <div *ngIf="displaySurvey" class="container-survey">
      <div class="container-survey-window" [ngClass]="submitted? 'small' : ''">
        <div class="container-inner-window">

          <div *ngIf="submitted" class="container-survey-content">
            <h3>Thank you for completing the survey! </h3>
            <p class="text-description">You can now close this modal.</p>

            <div class="container-final-buttons one-button">
              <button
                class="button-close blue full" (click)="closeAfterSubmit()"><p>Close</p>
              </button>
            </div>
          </div>

          <div *ngIf="!submitted" class="container-survey-content">
            <h3>{{MainSurveyTemplate.name}}</h3>
            <p class="text-description">{{MainSurveyTemplate.description}}</p>
            <div class="container-all-survey-questions">
              <div *ngFor="let SurveyQuestion of MainSurveyTemplate.questions; let i = index" class="container-survey-question">
                <p class="text-question">{{SurveyQuestion.text}}</p>
                <div class="container-survey-responses">
                  <div
                    class="container-single-response"
                    [ngClass]="isResponseSelected(i, 1)? 'selected' : ''"
                    (click)="onClickResponse(1, SurveyQuestion)">
                    <p>1</p>
                    <p class="text-agreement">Strongly Disagree</p>
                  </div>
                  <div
                    class="container-single-response"
                    [ngClass]="isResponseSelected(i, 2)? 'selected' : ''"
                    (click)="onClickResponse(2, SurveyQuestion)">
                    <p>2</p>
                    <p class="text-agreement">Somewhat Disagree</p>
                  </div>
                  <div
                    class="container-single-response"
                    [ngClass]="isResponseSelected(i, 3)? 'selected' : ''"
                    (click)="onClickResponse(3, SurveyQuestion)">
                    <p>3</p>
                    <p class="text-agreement">Somewhat Agree</p>
                  </div>
                  <div
                    class="container-single-response"
                    [ngClass]="isResponseSelected(i, 4)? 'selected' : ''"
                    (click)="onClickResponse(4, SurveyQuestion)">
                    <p>4</p>
                    <p class="text-agreement">Strongly Agree</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="container-final-buttons" [ngClass]="MainSurveyTemplate.required? 'one-button' : ''">
              <button *ngIf="!MainSurveyTemplate.required"
                class="button-close" (click)="close()"><p>Close</p>
              </button>
              <button class="button-submit blue" [disabled]="!canSubmit()" (click)="submit()"><p>Submit</p></button>
            </div>
          </div>
        </div>
      </div>
  </div>
</div>
